import React from 'react';
import './Policy.css';

function RefundPolicy() {
  return (
    <div className="policy">
      <div className="policy-header">
        <h1>REFUND POLICY</h1>
        <p>our commitment to your satisfaction</p>
      </div>
      <div className="policy-content">
        <section>
          <h2>RETURNS</h2>
          <p>we accept returns within 30 days of delivery for unused items in original condition.</p>
        </section>
        <section>
          <h2>REFUNDS</h2>
          <p>refunds will be processed within 5-7 business days of receiving your return.</p>
        </section>
        <section>
          <h2>DAMAGED ITEMS</h2>
          <p>if your item arrives damaged, please contact us immediately for a replacement or refund.</p>
        </section>
        <section>
          <h2>CUSTOM DESIGNS</h2>
          <p>custom designs are non-refundable unless there is a manufacturing defect.</p>
        </section>
      </div>
    </div>
  );
}

export default RefundPolicy; 